import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { useLanguage } from "@/context/LanguageContext";
import { toast } from "sonner";

function chime() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    [0, 0.2].forEach((start, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.frequency.value = [1046, 1318][i];
      gain.gain.setValueAtTime(0.0001, ctx.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(0.35, ctx.currentTime + start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + 0.4);
      osc.connect(gain).connect(ctx.destination);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + 0.45);
    });
    setTimeout(() => ctx.close(), 1500);
  } catch (e) {}
}

export function requestNotifyPermission() {
  if ("Notification" in window && Notification.permission === "default") Notification.requestPermission().catch(() => {});
}

export function useReadyAlert(onReady) {
  const { t } = useLanguage();
  const seen = useRef(null);

  useEffect(() => {
    const poll = () =>
      api.get("/orders/mine").then((r) => {
        const statuses = Object.fromEntries(r.data.map((o) => [o.order_id, o.status]));
        if (seen.current) {
          const ready = r.data.filter((o) => o.status === "ready" && seen.current[o.order_id] && seen.current[o.order_id] !== "ready");
          if (ready.length > 0) {
            navigator.vibrate?.([300, 120, 300, 120, 500]);
            chime();
            toast.success(t("order_ready_alert"), { duration: 8000, description: `${t("table")} ${ready.map((o) => o.table_number).join(", ")}` });
            if ("Notification" in window && Notification.permission === "granted" && document.hidden) {
              try { new Notification(t("order_ready_alert"), { body: t("order_ready_body"), tag: "order-ready" }); } catch (e) {}
            }
            onReady?.();
          }
        }
        seen.current = statuses;
      }).catch(() => {});
    poll();
    const id = setInterval(poll, 8000);
    return () => clearInterval(id);
  }, [t, onReady]);
}
